export default __webpack_public_path__ + "static/media/loading-icon.23240271.gif";